import { VisibilityOffOutlined, VisibilityOutlined } from '@mui/icons-material';
import {
  Box,
  TextField as TextFieldComponent,
  TextFieldProps,
} from '@mui/material';
import { useId, useState } from 'react';

import { InputLabel } from '../InputLabel';

export const TextField = ({
  sx,
  label,
  type,
  onKeyUp,
  onEnterPress,
  ...props
}: TextFieldProps & {
  value: TextFieldProps['value'];
  onEnterPress?: () => void;
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const id = useId();

  return (
    <Box
      sx={{
        ...(Array.isArray(sx) ? Object.assign({}, ...sx) : sx),
        display: 'flex',
        flexDirection: 'column',
      }}>
      {label && (
        <InputLabel label={`${label}${props.required ? ' *' : ''}`} id={id} />
      )}
      <TextFieldComponent
        id={`text-input-${id}`}
        variant="outlined"
        hiddenLabel
        size="small"
        type={type === 'password' && showPassword ? 'text' : type}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: 2,
            bgcolor: 'white',
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'secondary.main',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'secondary.main',
            },
          },
          '& .MuiInputBase-input': theme => ({
            ...theme.typography.body2,
          }),
          '& .MuiInputBase-input::-ms-clear': {
            display: 'none',
          },
          '& .MuiInputBase-input::-ms-reveal': {
            display: 'none',
          },
        }}
        onKeyUp={e => {
          if (e.key === 'Enter') {
            onEnterPress?.();
          } else {
            onKeyUp?.(e);
          }
        }}
        {...props}
        InputProps={{
          ...props.InputProps,
          endAdornment:
            type === 'password' ? (
              <Box
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                role="button"
                tabIndex={0}
                sx={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                {showPassword ? (
                  <VisibilityOutlined />
                ) : (
                  <VisibilityOffOutlined />
                )}
              </Box>
            ) : (
              props.InputProps?.endAdornment
            ),
        }}
      />
    </Box>
  );
};
